/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { menuDeltaProductRequestSchema } from "./menuDeltaProductRequestSchema.ts";

export const updateActivityProductsRequestSchema = menuDeltaProductRequestSchema;
